export enum GlobalFeature {}
